import React, { useState } from "react";
import "../../../../assets/scss/components/toc/orderPlacement/generic/opDropdown.scss";
import { IListObj } from "../../../types/genericTypes";

export interface IOpDropdownProps {
	defaultValue?: number | string; // default selected value
	dropdownOptions: Array<IListObj>; // list of all options in dropdown
	onOptionSelect: (id: string | number) => void; // the function to be called onSelect
}

const OpDropdown: React.FC<IOpDropdownProps> = (props: IOpDropdownProps) => {
	/**
	 * state and function for selectedValue
	 * selectedValue type is number | string
	 * setSelectedValue(number | string)
	 */
	const [selectedValue, setSelectedValue] = useState(props.defaultValue);

	/**
	 * state and function for isDropdownOpen
	 * selectedValue type is boolean
	 * setSelectedValue(boolean)
	 */
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	/**
	 * called when user selects an option
	 * @param id id of the selected option
	 * @returns onSelect prop passed from parent
	 */
	function optionSelected(id: string | number) {
		setSelectedValue(id);
		setIsDropdownOpen(false);
		return props.onOptionSelect(id);
	}

	// Find the selected object
	const selectedOption = props.dropdownOptions.find(option => selectedValue === option.value);

	return (
		<div className="op_dropdown">
			<button className="select_btn" onClick={() => setIsDropdownOpen(true)}>
				{/* show the value of selectedValue */}
				<span className="selected">{selectedOption?.display}</span>
				<i className="edel-icon-arrow-down" />
			</button>

			{/* when dropdown is open show overlay and content */}
			{/* Overlay covers the whole screen. When overlay is clicked, close the dropdown. */}
			{isDropdownOpen && <div className="dropdown_overlay" onClick={() => setIsDropdownOpen(false)} />}

			{/* Dropdown list */}
			<ul className={"dropdown" + (isDropdownOpen ? " active" : "")}>
				{/* Dropdown list */}
				{props.dropdownOptions.map((option, index) => (
					<li className="dropdown_item" key={option.value} onClick={() => optionSelected(option.value)}>
						<div className={"dropdown_content" + (option.value === selectedValue ? " active" : "")}>
							{/* show tick only if this option is selected */}
							{selectedValue && <i className={(option.value === selectedValue ? "edel-icon-tick " : "") + "tick"} />}
							{option.display}
						</div>
					</li>
				))}
			</ul>
		</div>
	);
};

export default OpDropdown;
